const WEBSITE_TITLE = "TRAXX D3 Portal";

export default {
  WEBSITE_TITLE
};